import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Sklad = {
	name: NAME,
	apiProvider,
	router,
};
